import * as React from "react";

export const gripMedium = ({fill}) => (
    <svg width="19px" height="18px" viewBox="0 0 19 19" xd-qa-type="icon" xd-qa-name="medium">
        <g transform="translate(1, 1)" fill={fill}>
            {[0,1,2].map((i) => (
                [0,1,2].map((j) => (
                    <rect
                        x={j*6} y={i*6}
                        key={j}
                        width="5" height="5" rx="0.5"
                    />
                ))
            ))}
        </g>
    </svg>
);

export const gripLarge = ({fill}) => (
    <svg width="19px" height="18px" viewBox="0 0 19 19" xd-qa-type="icon" xd-qa-name="large">
        <g transform="translate(1, 1)" fill={fill}>
            {[0,1].map((i) => (
                [0,1].map((j) => (
                    <rect
                        x={j*9.5} y={i*9}
                        key={j}
                        width="8.5" height="8.5" rx="0.5"
                    />
                ))
            ))}
        </g>
    </svg>
);

export const gripSmall = ({fill}) => (
    <svg width="19px" height="18px" viewBox="0 0 19 19" xd-qa-type="icon" xd-qa-name="small">
        <g transform="translate(1, 1)" fill={fill}>
            {[0,1,2,3].map((i) => (
                [0,1,2,3].map((j) => (
                    <rect
                        x={j*4.5} y={i*4.5}
                        key={j}
                        width="3.5" height="3.5" rx="0.5"
                    />
                ))
            ))}
        </g>
    </svg>
);